import React from 'react';
import PropTypes from 'prop-types';

import { AlertModal, Text } from '@cashfree-intl/coherent';

const ActivationFailed = ({ modalData, closeModal }) => (
  <AlertModal
    type="danger"
    title={`Failed to activate ${modalData.display}`}
    onClose={closeModal}
    eventNameOnClose={`Failed_To_Activate_${modalData.display}_Close`}
  >
    <Text color="bodyLight">
      There was an error in instantly activating {modalData.display}. We have
      submitted your request and our team will help you in activating it.
      <br /> Contact your account manager or write to us at{' '}
      <span className="w-700">care@cashfree.com</span> for further details.
    </Text>
  </AlertModal>
);

ActivationFailed.propTypes = {
  modalData: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
};

export default ActivationFailed;
